import React                                      from 'react';
import { KirokuLogicApplicated, KirokuInputIcon } from '../../../../../ui';
import * as moment                                from 'moment';
import { useHeadingQuestion }                     from '../../../../Records/useSurvey';
import { useScrollContext }                       from '../../../../../ui/Scrolling';
import { useTranslation }                         from 'react-i18next';

export default function DateTimeQuestion(props) {

    const { question, headerNextQuestion, value = null, isSurveyDetail } = props;

    const { optionalContentOrHeading } = useHeadingQuestion(question);
    const { scrollTo }                 = useScrollContext();
    const { t }                        = useTranslation();

    return (<div className={'pb-3'}>
        <div className='wraper-question'>
            <div className="background-question">
                <div className='number-question d-flex justify-content-between align-items-center'>

                    <div className="question-number text-overflow-elip">
                        {optionalContentOrHeading}
                    </div>
                    <div hidden={!isSurveyDetail} className={'float-right'}>
                        <KirokuLogicApplicated  padding={'5px 5px 5px 7px'} question={question}/>
                    </div>
                </div>
                <span className='content-name-question'>{question.content}</span>
                <div
                    hidden={typeof question.nextQuestion !== 'number' || !isSurveyDetail}
                    className='pl-10 height-text-next-question text-overflow-elip text-info scroll-link-question'
                    onClick={() => scrollTo(`question-survey-${question.nextQuestion}`, 202)}
                >
                    <i className='fas fa-arrow-right' style={{ paddingTop: 4 }}/>
                    <span className={'font-size-14'}> {headerNextQuestion}</span>
                </div>
            </div>
            <div className='answer-question'>
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <KirokuInputIcon readOnly name={'date'} icon={'far fa-calendar-alt'}
                                         style={{
                                             height       : '35px',
                                             paddingLeft  : '2rem',
                                             color        : '#0a1d42',
                                             pointerEvents: 'none',
                                         }}
                                         value={value ? moment.unix(value).format(t('dateTimeFormat.YearMonthDate')) : ''}
                        />
                        <div className={'mb-2 mt-2'}/>
                        <KirokuInputIcon readOnly name={'clock'} icon={'far fa-clock'}
                                         style={{
                                             height       : '35px',
                                             paddingLeft  : '2rem',
                                             color        : '#0a1d42',
                                             pointerEvents: 'none',
                                         }}
                                         value={value ? moment.unix(value).format(t('dateTimeFormat.HourMinute')) : ''}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>);
}
